import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import { rootLoader } from "./Loaders/rootLoader";
import {
  getChantier,
  getMaterial,
  getCustomer,
  getStaff,
  getEmpl,
  getFiles,
  getLogement,
  getDemAcc,
  getPpss,
} from "./apis";
import { lazy } from "react";
import { getFileInvoice, getInvoice } from "./apis/facture";
import { getVehicule } from "./apis/vehicule";
import { getProduct } from "./apis/prod";
import { getFuelCard } from "./apis/fuelCard";
import { getSettings } from "./apis/setting";
import { getfilesInvoiceCar, getVehiculeHistories, getVehiculeHistoriesByCar } from "./apis/vehiculeHistories";

const ViewsInvoiceCar = lazy(() => import("./pages/VehiculeHistory/ViewInvoiceCar"))
const NewVehiculeHistory = lazy(() => import("./pages/VehiculeHistory/NewVehiculeHistory"))
const NewPlanning = lazy(() => import("./pages/Planning/pages/NewPlanning"));
const ViewAgenda = lazy(() => import("./pages/Planning/pages/ViewAgenda"));
const NewLogement = lazy(() => import("./pages/Lodgement/pages/NewLogement"));
const GetLogement = lazy(() => import("./pages/Lodgement/pages/GetLogement"));
const NewFuelCard = lazy(() => import("./pages/FuelCard/pages/NewFuelCard"));
const GetFuelCard = lazy(() => import("./pages/FuelCard/pages/GetFuelCard"));
const NewProduct = lazy(() => import("./pages/Product/pages/NewProduct"));
const GetProduct = lazy(() => import("./pages/Product/pages/GetProduct"));
const Product = lazy(() => import("./pages/Product/Product"));
const NewVehicule = lazy(() => import("./pages/Vehicle/pages/NewVehicule"));
const GetVehicule = lazy(() => import("./pages/Vehicle/pages/GetVehicule"));
const ViewsInvoice = lazy(() => import("./pages/Invoice/pages/ViewsInvoice"));
const NewInvoice = lazy(() => import("./pages/Invoice/pages/NewInvoice"));
const GetInvoices = lazy(() => import("./pages/Invoice/pages/GetInvoices"));
const ViewsFicheRens = lazy(() => import("./pages/Staff/pages/ViewsFicheRens"));
const NewEmpl = lazy(() => import("./pages/empl/pages/NewEmpl"));
const GetEmpl = lazy(() => import("./pages/empl/pages/GetEmpl"));
const Empl = lazy(() => import("./pages/empl/Empl"));
const NewStaff = lazy(() => import("./pages/Staff/pages/NewStaff"));
const GetStaff = lazy(() => import("./pages/Staff/pages/GetStaff"));
const GetCustomers = lazy(() => import("./pages/Customers/pages/GetCustomers"));
const NewCustomer = lazy(() => import("./pages/Customers/pages/NewCustomer"));
const Customers = lazy(() => import("./pages/Customers/Customers"));
const ViewsDemAcc = lazy(
  () => import("./pages/ConstructionSite/pages/ViewsDemAcc")
);
const EditPpss = lazy(() => import("./pages/ConstructionSite/pages/editPpss"));
const ViewsPpss = lazy(
  () => import("./pages/ConstructionSite/pages/ViewsPpss")
);
const ProtectedRoute = lazy(
  () => import("./components/ProtectedRoute/ProtectedRoute")
);
const NewConstructionSite = lazy(
  () => import("./pages/ConstructionSite/pages/NewConstructionSite")
);
const GetConstrucionSite = lazy(
  () => import("./pages/ConstructionSite/pages/GetConstructionSite")
);
const Vehicle = lazy(() => import("./pages/Vehicle/Vehicle"));
const Staff = lazy(() => import("./pages/Staff/Staff"));
const Prestation = lazy(() => import("./pages/Prestation/Prestation"));
const Planning = lazy(() => import("./pages/Planning/Planning"));
const MaterialHistory = lazy(
  () => import("./pages/Material/pages/MaterialHistory")
);
const NewMaterial = lazy(() => import("./pages/Material/pages/NewMaterial"));
const FetchMaterial = lazy(
  () => import("./pages/Material/pages/FetchMaterial")
);
const Material = lazy(() => import("./pages/Material/Material"));
const Lodgement = lazy(() => import("./pages/Lodgement/Lodgement"));
const Invoice = lazy(() => import("./pages/Invoice/Invoice"));
const Homepage = lazy(() => import("./pages/Homepage/Homepage"));
const FuelCard = lazy(() => import("./pages/FuelCard/FuelCard"));
const ConstructionSite = lazy(
  () => import("./pages/ConstructionSite/ConstructionSite")
);
const ViewPresta = lazy(() => import("./pages/Prestation/pages/ViewPresta"));
const NewPresta = lazy(() => import("./pages/Prestation/pages/NewPresta"));
const Settings = lazy(() => import("./pages/Settings/Settings"));
const IndexProd = lazy(() => import("./pages/Product/pages/IndexProd"));
const GetVehiculeHistory = lazy(() => import("./pages/VehiculeHistory/GetVehiculeHistory"))


export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    loader: rootLoader,
    children: [
      {
        index: true,
        element: <Homepage />,
      },
      {
        path: "vehicle",
        element: <Vehicle />,
        children: [
            {
            index: true,
            element: <GetVehicule />,
            },
            {
            path: "newVehicule",
            element: <NewVehicule />,
            },
            {
            path: "edit/:vehiculeId",
            loader: async ({ params }) =>
            getVehicule(Number(params.vehiculeId)),
            element: <NewVehicule />,
            },
            {
            path: "history/:vehiculeId",
            loader: async ({ params }) =>
            getVehiculeHistoriesByCar(Number(params.vehiculeId)),
            element: <GetVehiculeHistory  />,               
                
            },
            {
                path: "editHistory/:vehiculeId",
                loader: async ({ params }) =>
                    getVehiculeHistories(Number(params.vehiculeId)),
                element: <NewVehiculeHistory />,

            },
            {
            path: "newVehiculeHistory/:vehiculeId",
            loader: async ({ params }) =>
                getVehicule(Number(params.vehiculeId)),
            element: <NewVehiculeHistory />,
            },
            {
                path: "invoice/:vehiculeId",
                loader: async ({ params }) => getfilesInvoiceCar(Number(params.vehiculeId)),
                element: <ViewsInvoiceCar />
            }
        ],
        },
        
      {
        path: "constructionSite",
        element: (
          <ProtectedRoute>
            <ConstructionSite />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <GetConstrucionSite />,
          },
          {
            path: "newConstructionSite",
            element: <NewConstructionSite />,
          },
          {
            path: "edit/:chantierId",
            loader: async ({ params }) =>
              getChantier(Number(params.chantierId)),
            element: <NewConstructionSite />,
          },
          {
            path: "viewsPpss/:chantierId",
            loader: async ({ params }) => getPpss(Number(params.chantierId)),
            element: <ViewsPpss />,
          },
          {
            path: "editPpss/:chantierId",
            loader: async ({ params }) =>
              getChantier(Number(params.chantierId)),
            element: <EditPpss />,
          },
          {
            path: "viewsDemAcc/:chantierId",
            loader: async ({ params }) => getDemAcc(Number(params.chantierId)),
            element: <ViewsDemAcc />,
          },
        ],
      },
      {
        path: "customers",
        element: <Customers />,
        children: [
          {
            index: true,
            element: <GetCustomers />,
          },
          {
            path: "newCustomer",
            element: <NewCustomer />,
          },
          {
            path: "edit/:idCustomer",
            loader: async ({ params }) =>
              getCustomer(Number(params.idCustomer)),
            element: <NewCustomer />,
          },
        ],
      },
      {
        path: "fuelCard",
        element: <FuelCard />,
        children: [
          {
            index: true,
            element: <GetFuelCard />,
          },
          {
            path: "newFuelCard",
            element: <NewFuelCard />,
          },
          {
            path: "edit/:idFuelCard",
            loader: async ({ params }) =>
              getFuelCard(Number(params.idFuelCard)),
            element: <NewFuelCard />,
          },
        ],
      },
      {
        path: "invoice",
        element: <Invoice />,
        children: [
          {
            index: true,
            element: <GetInvoices />,
          },
          {
            path: "newInvoice",
            element: <NewInvoice />,
          },
          {
            path: "edit/:idFact",
            loader: async ({ params }) => getInvoice(Number(params.idFact)),
            element: <NewInvoice />,
          },
          {
            path: "viewsInvoice/:idFact",
            loader: async ({ params }) => getFileInvoice(Number(params.idFact)),
            element: <ViewsInvoice />,
          },
        ],
      },
      {
        path: "lodgement",
        element: <Lodgement />,
        children: [
          {
            index: true,
            element: <GetLogement />,
          },
          {
            path: "newLogement",
            element: <NewLogement />,
          },
          {
            path: "edit/:logementId",
            loader: async ({ params }) =>
              getLogement(Number(params.logementId)),
            element: <NewLogement />,
          },
        ],
      },
      {
        path: "material",
        element: <Material />,
        children: [
          {
            index: true,
            element: <FetchMaterial />,
          },
          {
            path: "newMaterial",
            element: <NewMaterial />,
          },
          {
            path: "edit/:materialId",
            loader: async ({ params }) =>
              getMaterial(Number(params.materialId)),
            element: <NewMaterial />,
          },
          {
            path: "history/:materialId",
            loader: async ({ params }) =>
              getMaterial(Number(params.materialId)),
            element: <MaterialHistory />,
          },
        ],
      },
      {
        path: "product",
        element: <Product />,
        children: [
          {
            index: true,
            element: <GetProduct />,
          },
          {
            path: "newProduct",
            element: <NewProduct />,
          },
          {
            path: "edit/:productId",
            loader: async ({ params }) => getProduct(Number(params.productId)),
            element: <NewProduct />,
          },
          {
            path: "index",
            element: <IndexProd />,
          },
        ],
      },
      {
        path: "planning",
        element: <Planning />,
        children: [
          {
            index: true,
            element: <ViewAgenda />,
          },
          {
            path: "newPlanning",
            element: <NewPlanning />,
          },
        ],
      },
      {
        path: "prestation",
        element: <Prestation />,
        children: [
          {
            index: true,
            element: <ViewPresta />,
          },
          {
            path: "newPresta",
            element: <NewPresta />,
          },
        ],
      },
      {
        path: "staff",
        element: <Staff />,
        children: [
          {
            index: true,
            element: <GetStaff />,
          },
          {
            path: "newStaff",
            element: <NewStaff />,
          },
          {
            path: "edit/:staffId",
            loader: async ({ params }) => getStaff(Number(params.staffId)),
            element: <NewStaff />,
          },
          {
            path: "viewsFicheRend/:staffId",
            loader: async ({ params }) => getFiles(Number(params.staffId)),
            element: <ViewsFicheRens />,
          },
        ],
      },
      {
        path: "empl",
        element: <Empl />,
        children: [
          {
            index: true,
            element: <GetEmpl />,
          },
          {
            path: "newEmpl",
            element: <NewEmpl />,
          },
          {
            path: "edit/:idEmpl",
            loader: async ({ params }) => getEmpl(Number(params.idEmpl)),
            element: <NewEmpl />,
          },
        ],
      },
      {
        path: "settings",
        loader: async () => getSettings(),
        element: <Settings />,
      },
    ],
  },
]);
